// extracted by mini-css-extract-plugin
export default {"totalContainer":"cart_totalContainer__THFza","cartContainer":"cart_cartContainer__ePzRj","btn":"cart_btn__hWacQ"};